import {camelCaseIt} from 'case-it';

const can = (permission, item) => {
  if (gon.currentAdmin.isSuperAdmin) {
    return true
  }

  const provider = camelCaseIt(gon.currentProvider)
  const permissions = gon.currentAdmin.permissions[provider]
  const cannotManageApp = permissions === null || permissions === undefined
  const noPermission = permissions[permission] === null || permissions[permission] === undefined

  if (cannotManageApp || noPermission) {
    return false
  }

  if (permission === 'manage') {
    return true
  }

  return permissions[permission].includes(item)
}

export const canManage = () => {
  return can('manage', null)
}

export const canEdit = (item) => {
  return canManage(item) || can('edit', item)
}

export const canBan = (item) => {
  return canEdit(item) || can('ban', item)
}

export const canKenta = (item) => {
  return canBan(item) || can('kenta', item)
}
